// File: frontend/src/index.tsx
import React, { useState } from 'react';
import ReactDOM from "react-dom/client";
import { Header } from './components/header/Header';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Home } from './pages/home/home';
import { Projects } from './pages/projects/projects';
import { BoardMembers } from './pages/board/board';
import { About } from './pages/about/about';
import { Membership } from './pages/membership_applications/membership';
import { Events } from './pages/events/events';


const App = () => {

    const routes = [
        {
            path: "/",
            element: <Home />,
        },
        {
            path: "/projects",
            element: <Projects />,
        },
        {
            path: "/board",
            element: <BoardMembers />,
        },
        {
            path: "/about",
            element: <About />,
        },
        {
            path: "/membership-applications",
            element: <Membership />,
        },
        {
            path: "/events",
            element: <Events />,
        }
    ]
    const router = createBrowserRouter(routes);

    return (
        <div>
            {/* <h1>King's Rust Group</h1> */}
            <Header />
            <RouterProvider router={router} />
        </div>
    ); 
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
